// src/components/programs/ProgramForm/helpers/formValidationMessages.js

/**
 * Validation messages for program form
 */
export const getValidationMessages = (isArabic) => ({
    // Step 0 - Program Info
    title_ar_required: isArabic ? "العنوان بالعربية مطلوب" : "Title in Arabic is required",
    title_en_required: isArabic ? "العنوان بالإنجليزية مطلوب" : "Title in English is required",
    description_ar_required: isArabic ? "الوصف بالعربية مطلوب" : "Description in Arabic is required",
    description_en_required: isArabic ? "الوصف بالإنجليزية مطلوب" : "Description in English is required",
    agent_id_required: isArabic ? "يرجى اختيار الوكيل" : "Agent is required",
    start_date_required: isArabic ? "تاريخ البداية مطلوب" : "Start date is required",
    end_date_required: isArabic ? "تاريخ النهاية مطلوب" : "End date is required",
    end_date_invalid: isArabic
        ? "تاريخ النهاية يجب أن يكون بعد أو يساوي تاريخ البداية"
        : "End date must be after or equal to start date",
    pax_types_required: isArabic
        ? "يرجى اختيار نوع ركاب واحد على الأقل"
        : "Please select at least one pax type",
    cover_image_required: isArabic ? "صورة الغلاف مطلوبة" : "Cover image is required",
    city_ids_required: isArabic ? "يرجى اختيار مدينة واحدة على الأقل" : "Please select at least one city",

    // Step 1 - Itinerary
    itinerary_required: isArabic
        ? "الرجاء إضافة منتج واحد على الأقل"
        : "Please add at least one product",
    day_name_ar_required: isArabic ? "اسم اليوم بالعربية مطلوب" : "Day name in Arabic is required",
    day_name_en_required: isArabic ? "اسم اليوم بالإنجليزية مطلوب" : "Day name in English is required",
    pickup_time_required: isArabic ? "وقت الاستلام مطلوب" : "Pickup time is required",
    city_required: isArabic ? "المدينة مطلوبة" : "City is required",
    nights_required: isArabic ? "عدد الليالي مطلوب (الحد الأدنى: 0)" : "Nights is required (min: 0)",
    nights_exceeded: (maxNights) => isArabic
        ? `عدد الليالي لا يمكن أن يتجاوز ليالي البرنامج (${maxNights})`
        : `Nights cannot exceed program nights (${maxNights})`,
    time_required: isArabic ? "الوقت مطلوب" : "Time is required",
    units_required: isArabic ? "عدد الوحدات مطلوب (الحد الأدنى: 1)" : "Units is required (min: 1)",

    // Step 2 - Quotation
    discount_exceeded: isArabic
        ? "الخصم لا يمكن أن يتجاوز سعر المنتج"
        : "Discount cannot exceed product price",
    discount_percent_invalid: isArabic
        ? "النسبة المئوية يجب أن تكون بين 0 و 100"
        : "Percentage must be between 0 and 100",
    global_discount_invalid: isArabic
        ? "النسبة المئوية يجب أن تكون بين 0 و 100"
        : "Percentage must be between 0 and 100",

    // General
    fill_required_fields: isArabic
        ? "الرجاء تعبئة جميع الحقول المطلوبة بشكل صحيح"
        : "Please fill all required fields correctly",
    review_errors: isArabic
        ? "يرجى مراجعة جميع الحقول المطلوبة"
        : "Please review all required fields",
});
